<template>
    <v-list two-line style="max-height: 275px; min-height: 275px;" class="overflow-y-auto">
        <v-list-item-group v-model="selectedResources" multiple active-class="pink--text">
            <div class="text-center" style="margin-bottom: 7px;"><v-btn small color="primary" dark @click="on_selectAll">Select all</v-btn></div>
            <template v-for="(item, index) in get_selectedMultiEvents('PROCEEDING')">
                <v-list-item :key="item.originalId" :value="item" @dblclick="onDblClick_ProceedingItem(item)">
                    <template v-slot:default="{ active, toggle }">
                        <v-list-item-icon>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content draggable="true" @dragstart="dragStart(item, $event)" @dragover.prevent @dragenter="dragEnter" @dragleave="dragLeave" @dragend="dragEnd(item, $event)" @drop="dragFinish(item, $event)">
                            <v-list-item-title>
                                <strong>{{ get_Resource({ resourceId: item.resourceId, type: 'selectedhotellist' }) }}</strong>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--primary"><strong>{{ item.originalId }} {{ item.proObject.typeOfProceeding }}</strong> (to flight): <strong>{{ $locToUtcTDateTime(item.proObject.proceedingStart) }} - {{ $locToUtcTDateTime(item.proObject.proceedingEnd) }}</strong></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--primary">(Airp from: <strong>{{ item.proObject.codeAptFrom }}</strong>, Airp to: <strong>{{ item.proObject.codeAptTo }}</strong>), {{ item.proObject.proceedingFrom }} - {{ item.proObject.proceedingTo }}, Info: <strong>{{ item.proObject.info }}</strong></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-list-item-action-text>(id:{{ item.resourceId }})</v-list-item-action-text>
                        </v-list-item-action>
                    </template>
                </v-list-item>

                <v-divider v-if="index + 1 < get_selectedMultiEvents('PROCEEDING').length" :key="index"></v-divider>
            </template>
        </v-list-item-group>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name : 'selectedproceedingslist',

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Select all.
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/SelectedProceedingsList.vue >>> mounted');
            this.on_selectAll();

        }, // eo function mounted()


        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selectedResources: [], // selected Resources
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            selectedResources(value) {

                this.$emit('input', value);

            }, // eo function selectedResources()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Resource',
                'get_selectedMultiEvents', // get: selected Events
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * on_selectAll()
            *
            * Desc: Select all Resources.
            * Note:
            *
            */
            on_selectAll: function(){

                let me = this,
                    allResources = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/SelectedProceedingsList.vue >>> on_selectAll');
                this.get_selectedMultiEvents('PROCEEDING').forEach((item, i) => {
                    allResources.push(item);
                });
                this.selectedResources = [...allResources];

            }, // eo function on_selectAll()


            /*******************************************************************
            * onDblClick_ProceedingItem
            *
            * Desc: Double Click on 'Proceeding Item'.
            * Note: Just same emit here (like in: dragEnd).
            *
            * @param {Object} item ()
            */
            onDblClick_ProceedingItem: function(item) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/SelectedProceedingsList.vue >>> onDblClick_ProceedingItem');
                eventBus.$emit('dragendproceedingslist', { proObject: item.proObject });

            }, // eo function onDblClick_ProceedingItem




            /******************************************************************* 'Listeners - DnD'
            * Drag&Drop (DnD):
            *******************************************************************/
            /*******************************************************************
            * dragStart()
            *
            * Desc:
            * Note:
            *
            */
            dragStart: function(which, ev) {

                ev.dataTransfer.setData('Text', this.id); // leave this here
                ev.dataTransfer.dropEffect = 'move'; // leave this here
                // this.dragging = which;

            }, // eo function dragStart()


            /*******************************************************************
            * dragEnter()
            *
            * Desc:
            * Note:
            *
            */
            dragEnter: function(ev) {

                /*
                if (ev.clientY > ev.target.height / 2) {
                    ev.target.style.marginBottom = '10px'
                } else {
                    ev.target.style.marginTop = '10px'
                }
                */

            }, // eo function dragEnter()


            /*******************************************************************
            * dragLeave()
            *
            * Desc:
            * Note:
            *
            */
            dragLeave: function(ev) {

                // ev.target.style.marginTop = '2px';
                // ev.target.style.marginBottom = '2px';

            }, // eo function dragLeave()


            /*******************************************************************
            * dragEnd()
            *
            * Desc:
            * Note: Emit Event 'dragendproceedingslist'. Combos are listening.
            *
            */
            dragEnd: function(item, ev) {

                eventBus.$emit('dragendproceedingslist', { proObject: item.proObject });

            }, // eo function dragEnd()


            /*******************************************************************
            * dragFinish()
            *
            * Desc:
            * Note:
            *
            */
            dragFinish: function(to, ev) {

                //   this.moveItem(this.dragging, to);
                //   ev.target.style.marginTop = '2px'
                //   ev.target.style.marginBottom = '2px'

            }, // eo function dragFinish()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-card .v-divider {
        border-color: #d2d2d2;
    }

    .v-list-item {
        padding: 0 26px;
    }
</style>
